import "./ContactStage.css";
import { ReactComponent as StageViewBackground } from '../../../assets/StageViewBackground.svg';
import { STAGES, deriveContactStageModel, normalizeStage } from "./contactStageModel";

export default function ContactStage({ stage, deals, stageModel }) {
    const model = stageModel || deriveContactStageModel({ stage, deals });
    const occupiedStages = new Set(model?.occupiedStages || []);
    const effectiveStage = model?.effectiveStage || "new";

    return (
        <>
            <div className="contact-stages-container">
                {STAGES.map((stageLabel, index) => {
                    const normalizedLabel = normalizeStage(stageLabel);
                    const isPrimary = effectiveStage === normalizedLabel;
                    const isSecondaryOccupied = !isPrimary && occupiedStages.has(normalizedLabel);

                    const backgroundClassName = isPrimary
                        ? "contact-stage-background-active"
                        : isSecondaryOccupied
                            ? "contact-stage-background-occupied"
                            : "contact-stage-background";

                    const titleClassName = isPrimary
                        ? "contact-stage-title contact-stage-title-active"
                        : isSecondaryOccupied
                            ? "contact-stage-title contact-stage-title-occupied"
                            : "contact-stage-title";

                    return (
                        <div className={`contact-stage-container ${backgroundClassName}`} key={index}>
                            <h1 className={titleClassName}>{stageLabel}</h1>
                            {/* <StageViewBackground
                                className={backgroundClassName}
                                aria-hidden="true"
                                focusable="false"
                            /> */}
                        </div>
                    );
                })}
            </div>
        </>
    );
}